<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <billing-details
      :total-amount="totalAmount"
      :currency-icon="currencyIcon"
      :require-shipping="!!shipping.required"
      :is-good="shippingIsGood"
      @changed="updateBillingDetails"
    />
    <payment-options
      :billing-details="billing_details"
      :total-amount="totalAmount"
      :items="items"
      :is-ready="isReady"
      :use-client-amount="useClientAmount"
      :currency-icon="currencyIcon"
      :currency="currency"
      v-on="$listeners"
    />
    <mb-content
      name="checkout_info"
      style="font-size: smaller; line-height: initial; text-align: center;"
      light
      :render-config="renderConfig"
    />
  </v-container>
</template>

<script>
import PaymentOptions from './Options'
import BillingDetails from './BillingDetails'

export default {
  components: {
    BillingDetails, 
    PaymentOptions
  },
  props: {
    totalAmount: {
      type: Number,
      default: ()=>0
    },
    useClientAmount: {
      type: Boolean,
    },
    items: {
      type: Array,
      default: ()=>[]
    },
    currencyIcon: {
      type: String,
      default: ()=>null
    },
    currency: {
      type: String,
      default: ()=>null
    },
    shipping: {
      type: Object,
      default: ()=>{return {}}
    }
  },
  data(){
    return {
      billing_details: null,
      renderConfig: {
        divClass: 'lightCheckMessage',
        mermaid: {
          darkMode: false,
          textColor: 'blue'
        }
      }
    }
  },
  computed: {
    shippingIsGood(){
      return !!this.billing_details
        && !!this.billing_details.address
        && !!this.billing_details.address.line1
        && !!this.billing_details.address.city
        && !!this.billing_details.address.state
        && !!this.billing_details.address.postal_code
        // && !!this.billing_details.address.country
    },
    isReady(){
      return !!this.totalAmount
        && !!(this.billing_details||{}).email
        && !!(this.billing_details||{}).name
        && this.isReadyShipping
    },
    isReadyShipping(){
      if (!this.shipping.required) {
        return true
      }
      return !!this.shippingIsGood
    }
  },
  methods: {
    updateBillingDetails(v){
      this.billing_details = {...this.billing_details, ...v}
    },
  }
}
</script>

<style>
.lightCheckMessage {
  color: black !important;
}
</style>